import script from "./ReservationList.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationList.vue?vue&type=script&setup=true&lang=js"

import "./ReservationList.vue?vue&type=style&index=0&id=663d7bb5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-663d7bb5"]])

export default __exports__